  
export const MYREPORTER_API = process.env.VUE_APP_MYREPORTER_API;